import { Translation } from 'primeng/api';

/**
 * Spanish (es-MX) translation for PrimeNG's own built-in UI strings (table column
 * filter operators, calendar day/month names, file upload labels, etc). This is
 * separate from Angular's LOCALE_ID (used by pipes like `date`) — PrimeNG components
 * render these strings from this table instead of the active Angular locale.
 */
export const PRIME_NG_ES_TRANSLATION: Translation = {
  startsWith: 'Empieza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual a',
  notEquals: 'Distinto de',
  noFilter: 'Sin filtro',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  is: 'Es',
  isNot: 'No es',
  before: 'Antes de',
  after: 'Después de',
  dateIs: 'Fecha es',
  dateIsNot: 'Fecha no es',
  dateBefore: 'Fecha es anterior a',
  dateAfter: 'Fecha es posterior a',
  clear: 'Limpiar',
  apply: 'Aplicar',
  matchAll: 'Cumplir todas',
  matchAny: 'Cumplir alguna',
  addRule: 'Agregar regla',
  removeRule: 'Eliminar regla',
  accept: 'Sí',
  reject: 'No',
  choose: 'Elegir',
  upload: 'Subir',
  cancel: 'Cancelar',
  completed: 'Completado',
  pending: 'Pendiente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  chooseYear: 'Elegir Año',
  chooseMonth: 'Elegir Mes',
  chooseDate: 'Elegir Fecha',
  prevDecade: 'Década Anterior',
  nextDecade: 'Década Siguiente',
  prevYear: 'Año Anterior',
  nextYear: 'Año Siguiente',
  prevMonth: 'Mes Anterior',
  nextMonth: 'Mes Siguiente',
  prevHour: 'Hora Anterior',
  nextHour: 'Hora Siguiente',
  prevMinute: 'Minuto Anterior',
  nextMinute: 'Minuto Siguiente',
  prevSecond: 'Segundo Anterior',
  nextSecond: 'Segundo Siguiente',
  am: 'am',
  pm: 'pm',
  today: 'Hoy',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  dateFormat: 'dd/mm/yy',
  weak: 'Débil',
  medium: 'Medio',
  strong: 'Fuerte',
  passwordPrompt: 'Ingresa una contraseña',
  emptyFilterMessage: 'No se encontraron resultados',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'No hay elementos seleccionados',
  emptySearchMessage: 'No se encontraron resultados',
  emptyMessage: 'No hay opciones disponibles',
};
